import { MyModal } from 'components/Atoms';
import React from 'react';
import { Spin } from 'components/Atoms';
import { FormattedMessage } from 'react-intl';

const ProgressModal = ({
  visible = false,
  title = 'common.uploading',
}) => {
  return (
    <MyModal className="progress-modal" visible={visible} closable={false}>
      <div>
        <div className="uploading-icon">
          <Spin />
        </div>
        <div className="text-lg"><FormattedMessage id={title}/></div>
      </div>
    </MyModal>
  );
};
export default ProgressModal;
